import { render, staticRenderFns } from "./btn-text-primary.vue?vue&type=template&id=3fdc310c&scoped=true&"
import script from "./btn-text-primary.vue?vue&type=script&lang=js&"
export * from "./btn-text-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc310c",
  null
  
)

export default component.exports